<template>
  <v-btn
    small
    tile
    outlined
    depressed
    color="primary"
    dark
    @click="goToNewRequest"
    ><v-icon small color="primary">mdi-plus</v-icon>New Request</v-btn
  >
</template>
<script>
export default {
  methods: {
    goToNewRequest() {
      this.$router.push({ name: "New Request" });
    },
  },
};
</script>